import { documentReady } from "./utils/dom"
import klaroConfig from "./klaro/config"
import "./klaro/klaro.scss"
import * as klaro from "klaro/dist/klaro-no-css"

window.klaroConfig = klaroConfig

window.klaro = klaro

function showOrHideKlaro() {
  const klaroElement = document.getElementById("klaro-consent")

  if (!klaroElement) return

  const excludedPrefixes = [
    "/dashboard/",
    "/accounts/",
    "/privacy-policy/",
    "/agb/",
    "/impressum/",
    "/wellhub/",
  ]
  const currentPath = window.location.pathname

  const shouldHide = excludedPrefixes.some((prefix) => currentPath.startsWith(prefix))

  if (shouldHide) {
    klaroElement.classList.add("klaro-hide")
  } else {
    klaroElement.classList.remove("klaro-hide")
  }
}

documentReady(() => {
  if (document.getElementById(klaroConfig.elementID)) {
    window.klaro?.setup(window.klaroConfig)
    showOrHideKlaro()

    window.addEventListener("popstate", showOrHideKlaro)
    ;["pushState", "replaceState"].forEach((method) => {
      const original = history[method]
      history[method] = function (...args) {
        const result = original.apply(this, args)
        window.dispatchEvent(new Event(method.toLowerCase()))
        return result
      }
    })

    window.addEventListener("pushstate", showOrHideKlaro)
    window.addEventListener("replacestate", showOrHideKlaro)
  }
})
